(() => {
  if (window.hcHeroVideoLoaded) return;
  window.hcHeroVideoLoaded = true;
  const initialise = root => root.querySelectorAll('.hc-video-hero').forEach(section => {
    if (section.dataset.videoInitialised) return;
    const video = section.querySelector('.hc-video-hero__video');
    const button = section.querySelector('.hc-video-hero__playback');
    if (!video || !button) return;
    section.dataset.videoInitialised = 'true';
    const abort = new AbortController();
    const options = { signal: abort.signal };
    let userPaused = false;
    let playingRequest = false;
    let inView = true;
    const update = () => {
      section.classList.toggle('is-paused', video.paused);
      button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    };
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('controls');
    const play = () => {
      if (userPaused || document.hidden || !inView || !video.paused || playingRequest) return;
      video.muted = true;
      playingRequest = true;
      const request = video.play();
      if (request && request.then) request.then(update).catch(update).finally(() => { playingRequest = false; });
      else { playingRequest = false; update(); }
    };
    ['loadedmetadata', 'loadeddata', 'canplay'].forEach(event => video.addEventListener(event, play, options));
    ['playing', 'pause', 'error'].forEach(event => video.addEventListener(event, update, options));
    button.addEventListener('click', () => {
      if (video.paused) { userPaused = false; play(); }
      else { userPaused = true; video.pause(); }
    }, options);
    window.addEventListener('pageshow', play, options);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) play(); }, options);
    const gesturePlay = event => { if (!button.contains(event.target)) play(); };
    document.addEventListener('pointerdown', gesturePlay, { ...options, passive: true });
    document.addEventListener('touchstart', gesturePlay, { ...options, passive: true });
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      if (inView) play();
    }, { threshold: 0.01 });
    observer.observe(video);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(section)) { abort.abort(); observer.disconnect(); }
    }, options);
    update();
    play();
  });
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
